import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    attrs: {
      width: "800",
      persistent: ""
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: _vm.close
    }
  })], 1), _c(VCardTitle, {
    staticClass: "headline"
  }, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Manage default warehouse departure")])]), _c("div", {
    staticClass: "content-centered large"
  }, [_c("div", {
    staticClass: "tabs-container"
  }, [_c(VTabs, {
    attrs: {
      centered: ""
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, _vm._l(_vm.continents, function (continent) {
    return _c(VTab, {
      key: continent.iso
    }, [_vm._v(" " + _vm._s(continent.display_name) + " ")]);
  }), 1), _vm.isLoading ? _c("DefaultDeparturesComponent", {
    key: _vm.tab,
    attrs: {
      continent: _vm.continents[_vm.tab],
      listCountries: _vm.displayedCountries,
      listStates: _vm.listStates,
      warehouses: _vm.warehouses,
      defaultsDepartures: _vm.displayedDepartures
    },
    on: {
      reloaded: _vm.fetchDefaultDepartures
    }
  }) : _vm._e()], 1)]), _c("Confirm", {
    ref: "confirm"
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };